import * as validation from '@/utils/validation';

export default {
  data() {
    return {
      nickname: ""
    };
  },
  methods: {
    validate() {
      let errorMessage = this.check();

      if (errorMessage) {
        this.$buefy.toast.open({
          duration: 3000,
          message: errorMessage,
          type: 'is-danger'
        });
        return false;
      }

      return true;
    },
    check() {
      if (!this.nickname) {
        return "ニックネームを入れてください";
      }

      if (!validation.checkNGWord(this.nickname)) {
        return "ニックネームに不適切な表現が含まれています。";
      }

      return null;
    }
  }
}
